











import { Component, Mixins, Prop } from "vue-property-decorator";
import { IDocumentViewerMenuConfiguration } from "../document/viewers/contents";

@Component
export default class RightSidePane extends Mixins() {
  @Prop()
  width: string;

  @Prop({ default: true })
  isVisible: boolean;

  @Prop()
  viewerMenuConfiguration: IDocumentViewerMenuConfiguration;

  get style(): any {
    // v-ifで外からPane毎非表示にされるとslotで差し込んだコンポーネントが生成されないので一部で問題が発生.
    // (DocumentViewでdocumentの更新はRightSidePaneにslotで差し込んでるDocumentArchiveSelectorが行ってるため、生成されないと文書がロードされない.)
    // 幅を0に指定して見えないようにしていたが、safariは幅0指定しても実際の描画は0にならない問題あり.
    // UI側でブラウザごとに実装を変えるのは避けたいので、表示/非表示パラメータを用意してdisplay:none指定で非表示にする.
    return {
      display: this.isVisible ? undefined : "none",
      width: this.width,
    };
  }

  get shouldSpacePlaceBottom(): boolean {
    return !this.$configuration.style.panes.rightSide.shouldMainContentsPlaceBottom;
  }
}
